// Apolo IDE — diff-stat from a raw unified diff (GitConnectionBar, Sprint github E1).
//
// The Electron git IPC (`window.apolo.git.diff`) returns the RAW unified diff
// text (no --numstat). To show the "+291 −11" stat in the composer we count
// added/removed CONTENT lines, ignoring the file headers (`+++ b/…`, `--- a/…`)
// and the hunk markers (`@@ … @@`). Pure + deterministic so it's unit-tested.

/**
 * Count additions/deletions in a unified diff.
 * @param {string} diffText raw `git diff` output
 * @returns {{ additions: number, deletions: number }}
 */
export function computeDiffStat(diffText) {
  if (typeof diffText !== 'string' || diffText.length === 0) {
    return { additions: 0, deletions: 0 };
  }
  let additions = 0;
  let deletions = 0;
  // Splitting on \n keeps it O(n); we look only at the first char after
  // excluding the +++/--- file-header lines (which start with +++/---).
  const lines = diffText.split('\n');
  for (const line of lines) {
    if (line.startsWith('+++') || line.startsWith('---')) continue; // file headers
    if (line[0] === '+') additions += 1;
    else if (line[0] === '-') deletions += 1;
  }
  return { additions, deletions };
}

/**
 * Format a diff stat for display. Returns null when there's nothing to show
 * (clean worktree) so the caller can collapse the chip.
 * @param {{ additions: number, deletions: number } | null | undefined} stat
 * @returns {{ additions: number, deletions: number, label: string } | null}
 */
export function formatDiffStat(stat) {
  if (!stat) return null;
  const additions = Number.isFinite(stat.additions) ? stat.additions : 0;
  const deletions = Number.isFinite(stat.deletions) ? stat.deletions : 0;
  if (additions === 0 && deletions === 0) return null;
  // Uses the U+2212 MINUS SIGN like PullRequestCard for visual parity ("+291 −11").
  return { additions, deletions, label: `+${additions} −${deletions}` };
}
